exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntextarea {\n    height: auto;\n    padding: 16px 27px 16px;\n    width: 100%;\n    background-color: transparent;\n    outline: 0;\n    color: #838383;\n    font-size: 16px;\n    border: 2px solid #d5d5d5;\n    -webkit-transition: all 0.3s;\n    transition: all 0.3s;\n    letter-spacing: -0.5px;\n    font-family: 'Verdana', Helvetica, Arial, sans-serif;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-90fb6ff6","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/cart/winkelwagen.vue
// module id = fWfk
// module chunks = 3